import React from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { Chip } from "@mui/material";

const PortfolioGridPSTable = () => {
  const columns = [
    { field: "id", headerName: "ID", width: 20, hide: true },
    {
      field: "buildingName",
      headerName: "Building Name",
      width: 250,
      editable: false,
    },
    {
      field: "location",
      headerName: "Location",
      width: 180,
      editable: false,
    },
    {
      field: "buildingType",
      headerName: "Building Type",
      width: 140,
      editable: false,
    },
    {
      field: "managedSpace",
      headerName: "Managed Square Footage",
      width: 120,
      editable: false,
    },
    {
      field: "entryExitLogs",
      headerName: "Entry & Exit Logs",
      width: 120,
      editable: false,
    },
    {
      field: "visitorAccessManagement",
      headerName: "Visitor Access Management",
      width: 120,
      editable: false,
    },
    {
      field: "cameraCoverage",
      headerName: "Camera Coverage (Areas Monitored)",
      width: 200,
      editable: false,
    },
    {
      field: "accessControlCompliance",
      headerName: "Access Control Compliance",
      width: 200,
      editable: false,
    },
    {
      field: "incidentReports",
      headerName: "Incident Reports (Monthly Average)",
      width: 200,
      editable: false,
    },
  ];

  const rows = [
    {
      id: 1,
      buildingName: "Contoso Tower - Toronto",
      location: "Downtown Toronto, ON",
      buildingType: "Office",
      managedSpace: 150000,
      entryExitLogs: 2500,
      visitorAccessManagement: "Biometric",
      cameraCoverage: "Lobby, Corridors, Parking",
      accessControlCompliance: "Compliant",
      incidentReports: 2,
    },
    {
      id: 2,
      buildingName: "Contoso Plaza - Ottawa",
      builtYear: 2015,
      location: "ByWard Market, Ottawa, ON",
      buildingType: "Mixed-Use",
      managedSpace: 120000,
      entryExitLogs: 1900,
      visitorAccessManagement: "Key Card",
      cameraCoverage: "Entrance, Floors 1-50",
      accessControlCompliance: "Partially Compliant",
      incidentReports: 3,
    },
    {
      id: 3,
      buildingName: "Contoso Residences - Vancouver",
      builtYear: 2018,
      location: "Coal Harbour, Vancouver, BC",
      buildingType: "Residential",
      managedSpace: 90000,
      entryExitLogs: 2200,
      visitorAccessManagement: "Badge & PIN",
      cameraCoverage: "Exterior, Parking, Elevators",
      accessControlCompliance: "Compliant",
      incidentReports: 1,
    },
    {
      id: 4,
      buildingName: "Contoso Innovation Hub - Calgary",
      builtYear: 2021,
      location: "Downtown Calgary, AB",
      buildingType: "Office",
      managedSpace: 200000,
      entryExitLogs: 2800,
      visitorAccessManagement: "Biometric & Key Card",
      cameraCoverage: "Lobby, Emergency Exits",
      accessControlCompliance: "Compliant",
      incidentReports: 2,
    },
    {
      id: 5,
      buildingName: "Contoso Heights - Montreal",
      builtYear: 2016,
      location: "Plateau Mont-Royal, Montreal, QC",
      buildingType: "Residential",
      managedSpace: 110000,
      entryExitLogs: 1800,
      visitorAccessManagement: "RFID Badge",
      cameraCoverage: "Lobby, Corridors",
      accessControlCompliance: "Compliant",
      incidentReports: 1,
    },
    {
      id: 6,
      buildingName: "Contoso Wellness Center - Halifax",
      builtYear: 2012,
      location: "Downtown Halifax, NS",
      buildingType: "Healthcare",
      managedSpace: 95000,
      entryExitLogs: 3100,
      visitorAccessManagement: "Key Card & PIN",
      cameraCoverage: "Parking, Reception",
      accessControlCompliance: "Partially Compliant",
      incidentReports: 4,
    },
    {
      id: 7,
      buildingName: "Contoso Retail Space - Edmonton",
      builtYear: 2019,
      location: "West Edmonton Mall, AB",
      buildingType: "Commercial",
      managedSpace: 130000,
      entryExitLogs: 2600,
      visitorAccessManagement: "Biometric & Key Card",
      cameraCoverage: "Lobby, Elevators",
      accessControlCompliance: "Compliant",
      incidentReports: 1,
    },
    {
      id: 8,
      buildingName: "Contoso Eco Park - Saskatoon",
      builtYear: 2020,
      location: "Meewasin Valley, Saskatoon, SK",
      buildingType: "Mixed-Use",
      managedSpace: 70000,
      entryExitLogs: 2300,
      visitorAccessManagement: "RFID Badge",
      cameraCoverage: "Lobby, Exits, Parking",
      accessControlCompliance: "Compliant",
      incidentReports: 2,
    },
    {
      id: 9,
      buildingName: "Contoso Tower - Victoria",
      builtYear: 2014,
      location: "Downtown Victoria, BC",
      buildingType: "Office",
      managedSpace: 160000,
      entryExitLogs: 2100,
      visitorAccessManagement: "Key Card",
      cameraCoverage: "Lobby, Corridors, Roof Access",
      accessControlCompliance: "Compliant",
      incidentReports: 2,
    },
    {
      id: 10,
      buildingName: "Contoso Conference Center - Winnipeg",
      builtYear: 2018,
      location: "The Forks, Winnipeg, MB",
      buildingType: "Event Space",
      managedSpace: 85000,
      entryExitLogs: 2700,
      visitorAccessManagement: "Badge & Biometric",
      cameraCoverage: "All Floors, Roof, Parking",
      accessControlCompliance: "Compliant",
      incidentReports: 3,
    },
  ];

  return (
    <>
      <Box sx={{ height: "350px", width: "100%", overflow: "auto" }}>
        <DataGrid
          sx={{
            color: "white",
            "& .MuiDataGrid-menuIconButton": {
              color: "white",
            },
            "& .MuiCheckbox-root": {
              color: "white",
            },

            "& .MuiDataGrid-sortIcon": {
              color: "white",
            },

            "& .MuiTablePagination-root": {
              bgcolor: "white",
            },
            "& .MuiDataGrid-cell": {
              border: 0,
            },
            "& .MuiDataGrid-row:hover": {
              bgcolor: "primary.main",
            },
            "& .MuiDataGrid-cell:hover": {
              bgcolor: "none",
            },
            "& .MuiDataGrid-cell:focus": {
              bgcolor: "primary.light",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
              lineHeight: "1.5",
              whiteSpace: "normal",
            },

            "& .MuiDataGrid-cell": {
              textAlign: "center", // Centering cell content
            },
          }}
          rows={rows}
          columns={columns}
          initialState={{}}
          checkboxSelection
          disableRowSelectionOnClick
        />
      </Box>
    </>
  );
};

export default PortfolioGridPSTable;
